import { useEffect, useState } from 'react';

import { UNIPAY_APP_ID } from '@/shared/constants';
import { apiRequest } from '@/services';

declare global {
  interface Window {
    UnivapayCheckout?: any;
    checkout?: any;
  }
}
let cancelController: AbortController | null = null;

const useUnivaPayTokenMethod = () => {
  const { apiService } = apiRequest();

  const [isReady, setIsReady] = useState<boolean>(!!window.UnivapayCheckout);

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      !window.UnivapayCheckout &&
      !document.querySelector('#univapay-script')
    ) {
      const script = document.createElement('script');
      script.src = 'https://widget.univapay.com/client/checkout.js';
      script.id = 'univapay-script';
      script.async = true;
      script.onload = () => setIsReady(true);
      document.body.appendChild(script);
    } else if (
      typeof window !== 'undefined' &&
      window.UnivapayCheckout &&
      !isReady
    ) {
      setIsReady(true);
    }
  }, [isReady]);

  const handleCancelPayment = async (key?: string) => {
    if (!key) return;

    if (cancelController) {
      cancelController.abort();
    }

    cancelController = new AbortController();

    await apiService.coach.collection('clear', {
      method: 'POST',
      body: { key },
      signal: cancelController.signal,
    });
  };

  const handleSaveKeyIntoLocalStorage = (key?: string) => {
    if (!key) return;

    localStorage.setItem('tokenKeyPayment', key);
  };

  const startCheckout = (
    metadata: string,
    title: string,
    description: string,
    email: string,
    phoneNumber: string,
    onSuccessCallback: (subscriptionId: string) => void,
    key?: string,
  ) => {
    if (!window.UnivapayCheckout) {
      return;
    }

    const config = {
      appId: UNIPAY_APP_ID,
      checkout: 'token',
      requireName: true,
      requirePhoneNumber: true,
      size: 'large',
      className: 'btn_ips',
      autoSubmit: true,
      autoClose: true,
      title,
      tokenType: 'recurring',
      metadata: {
        'univapay-product-names': metadata,
      },
      description,
      email,
      phoneNumber,
      cvvAuthorize: true,
      currency: 'jpy',
      submitButtonText: '決済',
      locale: 'ja',
      onSuccess: (res: any) => {
        onSuccessCallback(res.tokenId);
      },
    };

    window.addEventListener('univapay:closed', () => handleCancelPayment(key));
    window.addEventListener('univapay:error', () => handleCancelPayment(key));
    window.addEventListener('beforeunload', () =>
      handleSaveKeyIntoLocalStorage(key),
    );
    window.addEventListener('unload', () => handleSaveKeyIntoLocalStorage(key));

    window.checkout = window.UnivapayCheckout.create(config);
    window.checkout?.open();
  };

  return {
    isReady,
    startCheckout,
  };
};

export default useUnivaPayTokenMethod;
